/* soolla-grid-autoload.js — turns the theme's "View more" pagination into a load-on-scroll grid.
   Clicks the existing .js-load-more (pagination.js) when it comes within 900px of the viewport, so all
   products arrive progressively (18 per page, images lazy) without a button. Button stays as no-JS fallback. */
(function () {
  function arm() {
    var btn = document.querySelector('product-grid-container .js-load-more'); if (!btn || btn.__sga) return; btn.__sga = true;
    document.documentElement.classList.add('sga-on');
    var io = new IntersectionObserver(function (es) {
      if (!es[0].isIntersecting) return;
      if (btn.disabled || btn.classList.contains('hide') || btn.classList.contains('btn--loading')) return;
      btn.click();
    }, { rootMargin: '900px 0px' });
    io.observe(btn);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arm); else arm();
  document.addEventListener('soolla:grid:replaced', arm);
})();
